import React from "react";
import { validatePhoneNumber } from "../popups/phonenumbers/AddRemoveNumbers";

function SMSBrandContactsDetails({register, watch, errors, setValue}) {
  return (
    <>
      <div className="general-settings">Contact Details</div>
      <div class="add-numbermain">
        <div class="tel-numbers">Name <span className="required" style={{margin:"0.2rem", color:"red"}}>*</span></div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <input
              class="form-control"
              name="groupName"
              {...register("contact_details.contact_name", {
                required: "Name is required",
              })}
            />
            {errors?.contact_details?.contact_name && (
                <p className="text-danger">
                  {errors?.contact_details?.contact_name?.message}
                </p>
              )}
          </div>
        </div>
      </div>
      <div class="add-numbermain">
        <div class="tel-numbers">Phone <span className="required" style={{margin:"0.2rem", color:"red"}}>*</span></div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <input
              class="form-control"
              name="groupName"
              {...register("contact_details.phno", {
                required: "Phone Number is required",
                validate: validatePhoneNumber
              })}
            />
            {errors?.contact_details?.phno && (
                <p className="text-danger">
                  {errors?.contact_details?.phno?.message}
                </p>
              )}
          </div>
        </div>
      </div>
      <div class="add-numbermain">
        <div class="tel-numbers">Email <span className="required" style={{margin:"0.2rem", color:"red"}}>*</span></div>
        <div class="d-flex w-30">
          <div class="phoneselect w-100">
            <input
              class="form-control"
              name="groupName"
              {...register("contact_details.email", {
                setValueAs: (v) => v?.trim(), 
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid Email",
                },
              })}
            />
             {errors?.contact_details?.email && (
                <p className="text-danger">
                  {errors?.contact_details?.email?.message}
                </p>
              )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SMSBrandContactsDetails;
